<template>
  <modal
    name="exercise-form"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('exercise-form')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <div class="fl-msg" />

      <div
        v-if="date"
        class="ui-block-title"
      >
        <h6 class="title">
          Exercise
        </h6>
      </div>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="submitRow"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 mt-3">
              <p><strong>Name</strong></p>
              <input
                v-model="item.name"
                class="form-group label-floating"
              >
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Description</strong></p>
              <wysiwyg v-model="item.description" />
            </div>
          </div>

          <button
            class="btn btn-lg btn-breez full-width mt-4"
            type="submit"
            name="submit"
          >
            <span>{{ item.id ? 'Edit' : 'Add' }} Exercise</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>

import VModal from 'vue-js-modal';
import Vue from 'vue'
import wysiwyg from 'vue-wysiwyg'
// import '../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
Vue.use(VModal, {dialog: true});
Vue.use(wysiwyg, {
  // { [module]: boolean (set true to hide) }
  hideModules: {
    bold: false,
    italic: false,
    underline: false,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    link: false,
    code: false,
    orderedList: true,
    unorderedList: true,
    image: false,
    table: true
  },
  // image: {
  //   uploadURL: IMAGE_URL,
  //   dropzoneOptions: {}
  // },
  forcePlainTextOnPaste: true
})

const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon";

export default {
  name: 'ExerciseForm',
  components: { AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      item: {
        cat_id: 0,
        title: '',
        description: ''
      },
      categories: [],
      date: new Date()
    }
  },
  created () {
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
      ? MODAL_HEIGHT - 200
      : MODAL_HEIGHT
  },
  methods: {
    dateSelected (date) {
      this.date = date
    },
    beforeOpen (event) {
      if (event.params.item) {
        this.item = event.params.item
      } else {
        this.item = {
          cat_id: 0,
          title: '',
          description: ''
        }
      }
    },
    // eslint-disable-next-line
      submitRow: function() { // !!!! this messes up if I use arrow function
      const payload = this.item
      if (this.item.id) {
        this.$store.dispatch('exercise/editExercise', payload)
      } else {
        this.$store.dispatch('exercise/addExercise', payload)
      }
    }
  }
}
</script>
